
































































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {IMessage} from '@/entities/notices'
import BaseButton from '@/components/BaseButton.vue'
import ModalSection from '@/components/ModalSection.vue'
import {decode as entityDecode} from 'he'
import Loading from '@/components/Loading.vue'
import {saveDailyCheckIn} from '@/api/notices'
import { timeSince } from '@/utils/time'
import EmojiOptionSelector from '@/components/EmojiOptionSelector.vue';
import NPSOptionSelector from '@/components/NPSOptionSelector.vue';
import SelectOptionSelector from '@/components/SelectOptionSelector.vue';

@Component<DailyCheckIn>({
  components: {
    SelectOptionSelector,
    NPSOptionSelector,
    EmojiOptionSelector,
    Loading,
    ModalSection,
    BaseButton
  },
  filters: {entityDecode, timeSince}
})
export default class DailyCheckIn extends Vue {
  @Prop({ type: Object, default: {} }) private message!: IMessage

  @Getter private userName
  @Getter private dailyCheckInData

  @Action private loadDailyCheckInData
  @Action private setDailyCheckInData

  public isLoading = true
  public previousAnswered = true

  public get npsChange()
  {
      return this.dailyCheckInData.feedback.yesterdayNps - this.dailyCheckInData.feedback.twoDaysAgoNps
  }

  public async mounted()
  {
      // if this is a daily check needing an answer for today
      if (!this.message.id) {
          this.previousAnswered = false
          await this.loadDailyCheckInData()
      } else {
          this.setDailyCheckInData(this.message.daily_check_in_data)
      }

      this.isLoading = false
  }

  public async checkIn()
  {
      const {data} = await saveDailyCheckIn(
          this.dailyCheckInData.dailyCheckInOption.id,
          this.dailyCheckInData.answer,
          this.dailyCheckInData.updateNotice ? this.dailyCheckInData.updateNotice.noticesrecipient_id : null
      )
      this.$emit('respond')
  }

  public updateAnswer(answer)
  {
      if (!this.previousAnswered) {
          this.dailyCheckInData.answer = answer
      }
  }

}

